// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuIconButton.saltButton{--saltButton-padding:0;--saltButton-minWidth:var(--salt-size-base);width:var(--saltButton-width,calc(var(--salt-size-base) + var(--salt-size-fixed-400)))}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
